import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components.
import InputHidden from './InputHidden';
import Toggle from './Toggle';
import Options from './Options';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

class Select extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedKey: '',
      selectedValue: props.value,
      collapsed: true,
    };

    // Bindings.
    this.onClickToggle = this.onClickToggle.bind(this);
    this.onClickOption = this.onClickOption.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
  }

  onClickToggle(event) {
    event.preventDefault();
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  }

  onClickOption(event, uid, content) {
    event.preventDefault();
    this.setState({
      selectedKey: uid,
      selectedValue: content,
      collapsed: true,
    });
    this.props.onChange({
      target: {
        name: this.props.id,
        value: uid,
      },
    });
    this.props.onBlur();
  }

  onFocusHandler(event) {
    const thisComponent = event.currentTarget;
    setTimeout(() => {
      if (thisComponent.contains(document.activeElement)) {
        this.props.onFocus();
      }
    }, 0);
  }

  onBlurHandler(event) {
    const thisComponent = event.currentTarget;
    setTimeout(() => {
      if (!thisComponent.contains(document.activeElement)) {
        this.setState({ collapsed: true }, this.props.onBlur);
      }
    }, 0);
  }

  render() {
    // Destructuring.
    const { className, id, placeholder, options } = this.props;
    const { selectedKey, selectedValue, collapsed } = this.state;

    // Determine whether options are showing or not.
    const active = collapsed === false;

    // Ensure toggle content displays even if its a zero.
    const toggleContent =
      selectedValue === 0 ? '0' : selectedValue || placeholder;

    // Classes.
    const classNameRoot = classNames('Select', className);
    const classNameToggle = classNames({
      'Toggle--valued': selectedKey !== '',
    });

    // Default render.
    return (
      <div className={classNameRoot} onBlur={this.onBlurHandler}>
        <InputHidden id={id} value={selectedKey} />
        <Toggle
          className={classNameToggle}
          active={active}
          onClick={this.onClickToggle}
          onFocus={this.onFocusHandler}
        >
          {toggleContent}
        </Toggle>
        <Options
          active={active}
          options={options}
          selected={selectedKey}
          onClickOption={this.onClickOption}
        />
      </div>
    );
  }
}

Select.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      content: PropTypes.node,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

Select.defaultProps = {
  className: null,
  placeholder: 'Select...',
  value: undefined,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select/index.js